module.exports = __webpack_public_path__ + "static/media/136.63113b52.webp";